import React, { Component } from 'react';
import PropTypes from 'prop-types';
import url from 'url';

import {
  getApartmentUrlPath,
  getApartmentPageMetadata,
} from 'common/apartmentHelpers';

import {
  PROPERTY_ATTRIBUTE_CATEGORY_LISTING_FIELD,
} from 'common/propertyAttributeConstants';

import {
  SCREEN_ID_APARTMENT,
} from 'client/constants/screenIds';

import {
  SR_API_ACTION_GET_APARTMENT_BY_ID,
} from 'api/actionTypes';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import Navbar from 'client/components/Navbar';
import SrApartmentPage from 'client/components/SrApartmentPage';
import ActivityIndicator from 'client/components/ActivityIndicator';
import NavbarButton from 'client/components/NavbarButton';
import SrNavbarToastButton from 'client/components/SrNavbarToastButton';
import SrContactModal from 'client/components/SrContactModal';
import SrLink from 'client/components/SrLink/SrLink';

import branch from 'client/core/branch';
import withApiState from 'client/helpers/withApiState';
import ApartmentActions from 'client/actions/Apartment';
import PropertyAttributeActions from 'client/actions/PropertyAttribute';
import { getPropertyAttributeListKeyId } from 'client/actions/PropertyAttribute/getList';

@withTransitionHook
@withScreenId(SCREEN_ID_APARTMENT)
@withScrollToTop
@withApiState({
  apartmentApiState: {
    action: SR_API_ACTION_GET_APARTMENT_BY_ID,
  },
})
@branch((props) => ({
  apartment: ['apartments', 'byId', props.match.params.apartmentId],
  floorPlans: ['apartments', 'floorPlansByApartmentId', props.match.params.apartmentId],
  apartmentSpecialDeals: ['apartments', 'specialDealsByApartmentId', props.match.params.apartmentId],
  appUrl: ['env', 'APP_URL'],
  listingHowDoILeaseSectionV1: [
    'analytics',
    'experiments',
    'activeVariants',
    'listingHowDoILeaseSectionV1',
  ],
  currentUser: ['currentUser'],
  propertyAttributes: [
    'propertyAttributes',
    'listBy',
    getPropertyAttributeListKeyId({
      apartmentId: props.match.params.apartmentId,
      category: PROPERTY_ATTRIBUTE_CATEGORY_LISTING_FIELD,
    }),
  ],
}))
class ApartmentPage extends Component {
  static propTypes = {
    apartment: PropTypes.object,
    floorPlans: PropTypes.array,
    apartmentSpecialDeals: PropTypes.array,
    appUrl: PropTypes.string.isRequired,
    apartmentApiState: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
    history: PropTypes.object.isRequired,
    listingHowDoILeaseSectionV1: PropTypes.string.isRequired,
    currentUser: PropTypes.object.isRequired,
  }

  static fetchData(match, inject) {
    return Promise.all([
      ApartmentActions.getById(inject, {
        apartmentId: parseInt(match.params.apartmentId, 10),
      }),
      ApartmentActions.getFloorPlansByApartmentId(inject, {
        apartmentId: parseInt(match.params.apartmentId, 10),
      }),
      ApartmentActions.getApartmentSpecialDealsByApartmentId(inject, {
        apartmentId: parseInt(match.params.apartmentId, 10),
      }),
      PropertyAttributeActions.getList(inject, {
        apartmentId: parseInt(match.params.apartmentId, 10),
        category: PROPERTY_ATTRIBUTE_CATEGORY_LISTING_FIELD,
      }),
    ]);
  }

  static getPageMetadata = (state, match) => {
    const apartment = state.get(['apartments', 'byId', match.params.apartmentId]);
    const appUrl = state.get(['env', 'APP_URL']);

    if (!apartment) {
      return {};
    }

    return getApartmentPageMetadata({ apartment, appUrl });
  }

  constructor(props) {
    super(props);

    this.state = {
      showContactModal: false,
    };
  }

  _onToggleContactModal = () => {
    this.setState({
      showContactModal: !this.state.showContactModal,
    });
  }

  render() {
    const {
      apartment,
      floorPlans,
      apartmentSpecialDeals,
      appUrl,
      apartmentApiState,
      dispatch,
      history,
      listingHowDoILeaseSectionV1,
      currentUser,
      propertyAttributes,
    } = this.props;

    const {
      showContactModal,
    } = this.state;

    const sunroomApartmentLink = apartment && url.resolve(appUrl, getApartmentUrlPath(apartment));

    const navbarProps = {
      leftButton: (
        <SrLink
          to='/feed'
          className='link back'
          restoreScrollPosition
          redirectToLastLocation
        >
          Back
        </SrLink>
      ),
      rightButton: (
        <SrNavbarToastButton
          toastLink={sunroomApartmentLink}
          toastContent='share link copied!'
          buttonContent={(
            <img
              className='share apartment'
              alt='share apartment'
              src='/images/share-icon.svg'
            />
          )}
          toggleToast
        />
      ),
      secondaryRightButton: (
        <NavbarButton
          onClick={this._onToggleContactModal}
        >
          <img
            className='phone apartment'
            alt='phone apartment'
            src='/images/phone-icon.svg'
          />
        </NavbarButton>
      ),
    };

    return (
      <div className='SrPage page-listing ApartmentPage'>
        <Navbar {...navbarProps} />
        {apartmentApiState.inProgress
          ? <ActivityIndicator />
          : (apartment
            ? (
              <SrApartmentPage
                apartment={apartment}
                floorPlans={floorPlans}
                propertyAttributes={propertyAttributes}
                apartmentSpecialDeals={apartmentSpecialDeals}
                dispatch={dispatch}
                history={history}
                listingHowDoILeaseSectionV1={listingHowDoILeaseSectionV1}
                currentUser={currentUser}
              />
            )
            : null
          )
        }
        {showContactModal &&
          <SrContactModal
            isOpen
            onClose={this._onToggleContactModal}
            url={sunroomApartmentLink}
            phoneNumber={currentUser?.customerSupportPhone}
          />
        }
      </div>
    );
  }
}

ApartmentPage.displayName = 'ApartmentPage';

export default ApartmentPage;
